module.exports = __webpack_public_path__ + "static/media/photoshop.a20ed0c9.jpg";